import { render, staticRenderFns } from "./body-attribute-line.vue?vue&type=template&id=123339d2&"
import script from "./body-attribute-line.vue?vue&type=script&lang=ts&"
export * from "./body-attribute-line.vue?vue&type=script&lang=ts&"
import style0 from "./body-attribute-line.vue?vue&type=style&index=0&id=123339d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports